import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

export const getReportingDateVersionString = (
  reportingDate: Util.FullDateStr,
  fileVersion: number,
) => {
  return `Reporting Date: ${commonDate.fullDateStrToHumanDateString(
    reportingDate,
  )}, Version ${fileVersion}`;
};

export const getReportingDateVersionShortString = (
  reportingDate: Util.FullDateStr,
  fileVersion: number,
) => {
  return `Reporting Date: ${commonDate.fullDateStrToShortMonthDayString(
    reportingDate,
  )}, Version ${fileVersion}`;
};
